export default __webpack_public_path__ + "static/media/sticker-r.f6abebcd.png";